module.exports = __webpack_public_path__ + "static/img/index-t2.4efe842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-t2.jpg
// module id = hc7a
// module chunks = 11